module.exports = __webpack_public_path__ + "img/icon_nav_more.695ef0d1.svg";